export default [
  {
    header: 'Игроки',
    resource: 'players',
    action: 'view',
  },
  {
    title: 'Рейтинг',
    route: 'players-rating',
    icon: 'AwardIcon',
    resource: 'players',
    action: 'view',
  },
]
